import { AuthImage } from './AuthImage';
import { useLightbox } from './Lightbox';

/**
 * An image embedded in a message body / editor. Capped size, click to enlarge
 * in the lightbox. Used by the Lexical ImageNode decorator and by the
 * RichTextDisplay inline-image swap.
 */
export function InlineImage({ attachmentId, alt }: { attachmentId: string; alt: string }) {
  const lightbox = useLightbox();
  return (
    <AuthImage
      id={attachmentId}
      alt={alt}
      onClick={() => lightbox.open(attachmentId, alt)}
      className="max-h-80 max-w-full rounded-md border cursor-zoom-in my-1"
    />
  );
}
